// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","intro":"App_intro__NI3Vg","introText":"App_introText__gpbrT"};